<template>
  <div class="pl-page">
    <pro-list-frame
      v-if="isDesktopListLayout"
      ref="plTable"
      :title="($t($route.name))"
      icon="mdi-swap-vertical-bold"
      :total="totalItems"
      :rows="items.length"
      :search.sync="search"
      :columns="toggleableHeaders"
      :hidden="hiddenColumns"
      :selected-count="(selected || []).length"
      :loading="loading"
      :cell-sel="cellSel"
      :fixed="!mobileShow"
      :create-label="$t(type)"
      @refresh="getItems"
      @print="printStudio = true"
      @filter="filter = true"
      @create="goTo(type)"
      @toggle-column="toggleColumn"
      @show-all-columns="hiddenColumns = []"
      @cell-down="onCellDown"
      @cell-over="onCellOver"
      @clear-cells="clearCellSel"
      @clear-selection="selected = []"
    >
      <template #tools>
      <export-excel
        ref="refExcel"
        :data="excelItems"
        worksheet="abriron.com"
        name="data.xls"
        type="xls"
        :title="$store.state.abrName"
        :total-prop="pageCount"
        :page-prop="excelPage"
        @getAllRows="getAllRows"
      >
        <button type="button" class="pl-btn pl-btn--icon" :title="$t('excel')">
          <v-icon size="16" color="#2E7D32">mdi-file-excel-outline</v-icon>
        </button>
      </export-excel>
      <v-menu offset-y left>
        <template v-slot:activator="{ attrs, on }">
          <button type="button" class="pl-btn pl-btn--icon" v-bind="attrs" v-on="on">
            <v-icon size="16">mdi-dots-vertical</v-icon>
          </button>
        </template>
        <v-list dense>
          <log
            v-if="
              $store.state.permissions && $store.state.permissions.includes('logList')
            "
            ref="logRef"
            :type-prop="typeForm"
            :listProp="true"
            mode-prop="button"
          />
          
          
          
          
        </v-list>
      </v-menu>
      </template>
      <template #bulk>
      <button
        type="button"
        class="pl-bulk__btn pl-bulk__btn--danger"
        @click="deletDialog = true"
      >
        <v-icon size="17">mdi-trash-can-outline</v-icon>
        {{ $t("remove") }}
      </button>
      </template>
      <v-data-table
        v-if="headers"
        ref="listTable"
        v-column-resize="productTurnoverColumnPlugins"
        v-column-drag="productTurnoverColumnPlugins"
        v-column-pin="productTurnoverColumnPlugins"
        :height="mobileShow ? 323 : plTableH"
        fixed-header
        v-model="selected"
        :headers="tableHeaders"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="false"
        multi-sort
        :page.sync="page"
        dense
        :show-select="showSelect"
        item-key="id"
        :footer-props="plFooterProps"
      >
        <template v-slot:item.actions="{ item }">
          <div class="pl-action-cell">
          <v-menu offset-y>
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                color="primary"
                class="pl-action-cell__btn"
                v-bind="attrs"
                icon
                x-small
                v-on="on"
              >
                <v-icon small>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item
                link
                :disabled="item.head.lock == 'active'"
                @click="edit(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-clipboard-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('edit')" />
              </v-list-item>
              <v-list-item
                v-if="item.head"
                v-clipboard:copy="$baseURL + '/' + item.head.type + '/edit/' + item.id"
                link
              >
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('copy-link')" />
              </v-list-item>
            </v-list>
          </v-menu>
          <span class="pl-action-cell__row">
            <a @click="item.head.lock != 'active' && edit(item)">{{
              parseInt(items.indexOf(item)) + parseInt(from)
            }}</a>
          </span>
          </div>
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div v-if="item.user" color="primary" dark v-bind="attrs" v-on="on">
                {{ item.user.firstname }} {{ item.user.lastname }}
              </div>
            </template>
            <span>{{ item.time }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.head.type="{ item }">
          <v-icon size="15" v-if="item.head && item.head.lock == 'active'">
            mdi-lock
          </v-icon>
          <v-btn
            v-if="item.head"
            :loading="loading"
            class="ma-0 px-1"
            :color="
              item.head.type === 'remittance'
                ? 'pink'
                : item.head.type === 'receipt'
                ? 'teal'
                : 'blue'
            "
            plain
            @click="
              item.head.type !== 'initial' &&
              item.head.type !== 'production' &&
              item.head.lock != 'active'
                ? edit(item)
                : null
            "
          >
            {{ $t(item.head.type) }} {{ $t("number") }} : {{ item.head.id }}
          </v-btn>
          <v-chip
            v-if="item.head && item.head.invoice"
            :color="
              item.head.type === 'remittance'
                ? 'pink'
                : item.head.type === 'receipt'
                ? 'teal'
                : 'blue'
            "
            small
            outlined
            label
            @click="invoice(item)"
          >
            {{ $t(item.head.invoice.type) }} - {{ $t("number") }}
            {{ item.head.invoice.number }} (id:{{ item.head.invoice.id }})
            {{
              item.head && item.head.invoice && item.head.invoice.customer
                ? " - " + item.head.invoice.customer.name
                : ""
            }}
          </v-chip>
          <v-chip
            v-if="item.head && item.head.production"
            color="teal"
            small
            outlined
            label
            @click="invoice(item)"
          >
            {{ $t(item.head.production.type) }} - {{ $t("number") }}
            {{ item.head.production.number }} (id:{{ item.head.production.id }})
          </v-chip>
        </template>
        <template v-slot:item.price="{ item }">
          {{ $numberFormat(item.price, "currency", $store.state.currency.decimal) }}
        </template>
        <template v-slot:item.invoiceArticle.fee="{ item }">
          {{
            $numberFormat(
              item?.invoiceArticle?.fee ?? 0,
              "currency",
              $store.state.currency.decimal
            )
          }}
        </template>
        <template v-slot:item.in="{ item }">
          {{ $numberFormat(item.in, "number") }}
          {{
            item.unit2 && item.in
              ? "(" + item.countUnit + " " + item.unit2.fame + ")"
              : ""
          }}
        </template>
        <template v-slot:item.out="{ item }">
          {{ $numberFormat(item.out, "number") }}
          {{
            item.unit2 && item.out
              ? "(" + item.countUnit + " " + item.unit2.fame + ")"
              : ""
          }}
        </template>
        <template v-slot:item.checked_count="{ item }">
          {{ $numberFormat(item.checked_count, "number") }}
        </template>
        <template v-slot:item.id="{ item }">
          <a @click="item.head.lock != 'active' && edit(item)">
            {{ item.id }}
          </a>
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template>
        <template v-slot:item.sumCount="{ item }">
          {{ $numberFormat(item.sumCount.toFixed(3), 3) }}
          <!-- {{ $numberFormat(item.sumCount, 3) }} {{ item }} -->
        </template>
        <template v-slot:item.sumAmount="{ item }">
          {{ $numberFormat(item.sum.toFixed($store.state.currency.decimal)) }}
        </template>
        <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
          {{ faNum(pageStart) }}–{{ faNum(pageStop) }} {{ $t("of") }} {{ faNum($numberFormat(itemsLength)) }}
        </template>
        <template v-slot:footer.prepend>
          <!-- Desktop fixed viewport: page totals sit above pagination, outside body scroll -->
          <div
            v-if="!isMobile && !mobileShow"
            class="app-list-page-totals"
          >
            <span class="app-list-page-totals__label">{{ $t("sum") }}</span>
            <span class="app-list-page-totals__item">
              <span class="app-list-page-totals__key">{{ $t("in") }}</span>
              <span class="app-list-page-totals__val">
                {{ $numberFormat(totals.in, "number") }}
              </span>
            </span>
            <span class="app-list-page-totals__item">
              <span class="app-list-page-totals__key">{{ $t("out") }}</span>
              <span class="app-list-page-totals__val">
                {{ $numberFormat(totals.out, "number") }}
              </span>
            </span>
            <span
              class="app-list-page-totals__item app-list-page-totals__item--final"
            >
              <span class="app-list-page-totals__key">{{ $t("remain") }}</span>
              <span class="app-list-page-totals__val">
                {{
                  parseFloat((+totals.in - +totals.out).toFixed(10)).toLocaleString(
                    "en-US",
                    {
                      maximumFractionDigits: 10,
                    }
                  )
                }}
              </span>
            </span>
          </div>
          <div class="pl-goto">
            <span>{{ $t("goToPage") }}</span>
            <input v-model.number="page" type="number" min="1" :max="pageCount" class="pl-goto__input pl-num" />
            <span class="pl-num">/ {{ faNum(pageCount) }}</span>
          </div>
        </template>
        <template v-slot:body.append>
          <tr
            v-if="isMobile || mobileShow"
            :class="{ 'v-data-table__mobile-table-row': isMobile }"
          >
            <td
              :colspan="`${isMobile ? 6 : 7}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              <strong>{{ $t("sum") }}</strong>
            </td>
            <td
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ isMobile ? $t("in") + ":" : "" }}
              <!-- {{ $numberFormat(totals.in.toFixed(3)) }} -->
              {{ $numberFormat(totals.in, "number") }}
            </td>
            <td
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ isMobile ? $t("out") + ":" : "" }}
              <!-- {{ $numberFormat(totals.out.toFixed(3)) }} -->
              {{ $numberFormat(totals.out, "number") }}
            </td>
            <td
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ $t("remain") }} :
              <!-- {{ $numberFormat((+totals.in - +totals.out).toFixed(3)) }} -->
              <!-- {{ $numberFormat(+totals.in - +totals.out, "number") }} -->
              {{
                parseFloat((+totals.in - +totals.out).toFixed(10)).toLocaleString(
                  "en-US",
                  {
                    maximumFractionDigits: 10,
                  }
                )
              }}
            </td>
            <td
              :colspan="`${isMobile ? 6 : 4}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            />
          </tr>
        </template>
      </v-data-table>
    </pro-list-frame>
    <pro-list-mobile
      v-else
      :title="($t($route.name))"
      :items="items"
      :total="totalItems"
      :loading="loading"
      :page="plPage"
      :page-count="pageCount || 1"
      :search.sync="search"
      :filterable="true"
      :printable="true"
      :card="plAutoCard"
      :actions="plAutoActions"
      :create-label="$t(type)"
      @load-more="plLoadPage"
      @refresh="plLoadPage(1)"
      @print="printStudio = true"
      @filter="filter = true"
      @create="goTo(type)"
    />
    <print-studio
      v-model="printStudio"
      :report="plReportKey"
      :title="($t($route.name))"
      :columns="plPrintCols"
      :source="plPrintSource"
      @error="serverErrorHandeler"
    />

    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="printDialog"
      width="70%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="printDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <print
            :header-prop="showHeaders"
            :items-prop="items"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
        <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="filter"
      max-width="960"
      scrollable
      content-class="acf-wrap"
    >
      <div class="acf acf--compact" :style="proListRootStyle" dir="rtl">
        <header class="acf-head">
          <span class="acf-head__icon">
            <v-icon size="18">mdi-filter-variant</v-icon>
          </span>
          <div class="acf-head__titles">
            <div class="acf-head__title">{{ productTurnoverFilterTitle }}</div>
            <div class="acf-head__sub">
              <template v-if="activeFilterChips.length">
                <span class="acf-badge">{{ faNum(activeFilterChips.length) }}</span>
                {{ $t("accFilterActive") }}
              </template>
              <template v-else>{{ $t("accFilterNone") }}</template>
            </div>
          </div>
          <button type="button" class="acf-x" :title="$t('close')" @click="filter = false">
            <v-icon size="18">mdi-close</v-icon>
          </button>
        </header>

        <div class="acf-body">
          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-package-variant-closed</v-icon>
              {{ $t("productFilterMain") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <autocomplete
                v-model="product"
                type="product"
                :title="$t('product')"
                :outlined="true"
              />
              <autocomplete
                v-model="entrepot"
                :title="$t('entrepot')"
                type="entrepot"
                :outlined="true"
                :multiple="true"
                :filter="true"
              />
              <autocomplete
                v-model="branch"
                title="branch"
                type="branch"
                :filter="true"
                :multiple="true"
              />
              <v-select
                v-model="statusControll"
                :label="$t('statusControll')"
                :items="statusItems"
                dense
                outlined
                clearable
                hide-details
                item-value="value"
                item-text="text"
              />
              <v-select
                v-model="documentType"
                :label="$t('type')"
                :items="documentTypeItems"
                dense
                outlined
                clearable
                hide-details
                item-value="value"
                item-text="text"
              />
              <v-select
                v-model="invoiceType"
                :label="$t('type') + ' ' + $t('invoice')"
                :items="invoiceTypeItems"
                dense
                outlined
                clearable
                hide-details
                item-value="value"
                item-text="text"
              />
              <autocomplete
                v-model="registerar"
                :title="$t('registerar')"
                type="partners"
                :multiple="true"
                :filter="true"
              />
            </div>
          </section>

          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-calendar-range</v-icon>
              {{ $t("accFilterDateTime") }}
            </div>
            <div class="acf-grid acf-grid--4">
              <div>
                <v-text-field
                  id="fromId"
                  v-model="fromDate"
                  :label="$t('from') + ' ' + $t('date')"
                  prepend-inner-icon="mdi-calendar-start"
                  outlined
                  dense
                  clearable
                  hide-details
                />
                <date-picker
                  v-model="fromDate"
                  element="fromId"
                  :locale="$store.state.date_locale"
                  :format="$store.state.date_format"
                  auto-submit
                  :color="
                    $vuetify.theme.themes[
                      $vuetify.theme.isDark ? 'dark' : 'light'
                    ].primary
                  "
                  @close="setDate"
                />
              </div>
              <div>
                <v-text-field
                  id="toId"
                  v-model="toDate"
                  :label="$t('until') + ' ' + $t('date')"
                  prepend-inner-icon="mdi-calendar-end"
                  outlined
                  dense
                  clearable
                  hide-details
                />
                <date-picker
                  v-model="toDate"
                  element="toId"
                  :locale="$store.state.date_locale"
                  :format="$store.state.date_format"
                  :min="fromDate"
                  auto-submit
                  :color="
                    $vuetify.theme.themes[
                      $vuetify.theme.isDark ? 'dark' : 'light'
                    ].primary
                  "
                  @close="setDate"
                />
              </div>
              <v-select
                v-model="selectedHeaders"
                :items="headers"
                :label="$t('sellFilterColumns')"
                dense
                outlined
                multiple
                return-object
                hide-details
              >
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0" class="acf-sel">{{ item.text }}</span>
                  <span v-if="index === 1" class="acf-sel acf-sel--more">
                    +{{ faNum(selectedHeaders.length - 1) }}
                  </span>
                </template>
              </v-select>
            </div>
          </section>
        </div>

        <footer class="acf-foot">
          <button type="button" class="acf-btn acf-btn--primary" @click="getItems">
            <v-icon size="16">mdi-filter-check-outline</v-icon>
            {{ $t("accFilterApply") }}
          </button>
          <button
            type="button"
            class="acf-btn acf-btn--ghost"
            :disabled="!activeFilterChips.length"
            @click="resetFilters"
          >
            <v-icon size="16">mdi-filter-remove-outline</v-icon>
            {{ $t("accDocListClearFilters") }}
          </button>
          <span class="acf-spacer" />
          <button type="button" class="acf-btn" @click="filter = false">
            {{ $t("cancel") }}
          </button>
        </footer>
      </div>
    </v-dialog>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="taskDialog"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="taskDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("task") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="deletDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img class="mx-auto" width="200" src="@/assets/stop.svg" />
        </v-col>
        <v-col class="mt-3 pr-7">
          <p class="mx-auto font-weight-medium">
            {{ $t("are-you-sure-delete-this-case") }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn v-if="selected.length > 0" color="primary" @click="removegroup">
                {{ $t("remove") }}
              </v-btn>
              <v-btn v-if="selected.length == 0" color="primary" @click="remove">
                {{ $t("remove") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </div>
</template>

<script>
import Task from "../task/task";
import Print from "../../components/general/Print/Index";
import General from "../../../../Mixins/general";
import autocomplete from "../../components/general/patial/autocomplete";
import {
  applyColumnSettings,
  loadColumnSettings,
} from "@/plugins/columnSettings/columnSettings";
import { reorderPinnedHeaders } from "@/plugins/columnPin/columnPin";
import ProList from "@/Mixins/proList";
import ProListFrame from "@/components/proList/ProListFrame.vue";
import ProListMobile from "@/components/proList/ProListMobile.vue";
import PrintStudio from "@/modules/print/PrintStudio.vue";
export default {
  name: "ProductTurnover",
  components: {
    ProListFrame,
    ProListMobile,
    PrintStudio,
    Snakbar: () => import("../../components/general/snakbar/snakbar"),
    Print,
    autocomplete,
    Task,
  },
  mixins: [General, ProList],
  props: ["input", "refId", "productProp", "entrepotProp", "idProp", "mobileShow"],
  data: () => ({
    documentType: null,
    documentTypeItems: [],
    invoiceType: null,
    invoiceTypeItems: [],
    registerar: null,
    statusItems: [],
    excelItems: [],
    selected: [],
    pageCount: 1,
    page: 1,
    printDialog: false,
    deletDialog: false,
    filter: false,
    sumAmount: 0,
    sumCount: 0,
    statusControll: null,
    entrepot: null,
    product: null,
    productStatus: null,
    productStatusItems: null,
    model: null,
    from: 1,
    taskDialog: null,
    tag: null,
    temp: null,
    deleteItem: null,
    sellStatus: null,
    fromDate: null,
    toDate: null,
    items: [],
    sortBy: [],
    dialog: null,
    timer: 0,
    totalItems: 0,
    snakbar: false,
    typeForm: null,
    taskId: null,
    snakbarText: null,
    loading: true,
    options: {
      itemsPerPage: 5,
    },
    headers: null,
    listViewportObserver: null,
    listViewportRaf: null,
    type: null,
    search: null,
    selectedHeaders: [],
    headersMap: null,
    fin4: null,
    given: null,
  }),
  computed: {

    productTurnoverFilterTitle() {
      var map = {
        productCountTurnover: "productCountTurnoverFilterTitle",
        productAmountTurnover: "productAmountTurnoverFilterTitle",
        productTurnoverDetails: "productTurnoverDetailsFilterTitle",
        productTurnoverSingle: "productTurnoverFilterTitle",
      };
      var key = map[this.$route.name] || "productTurnoverFilterTitle";
      return this.$t(key);
    },
    activeFilterChips() {

      var app = this;
      var has = function (v) {
        if (Array.isArray(v)) return v.length > 0;
        return v !== null && v !== undefined && v !== "" && v !== "0" && v !== 0;
      };
      var show = function (v) {
        if (Array.isArray(v)) return v.length > 1 ? String(v.length) : show(v[0]);
        if (v && typeof v === "object") return v.name || v.text || v.label || "";
        return typeof v === "number" || typeof v === "string" ? String(v) : "";
      };
      var pick = function (items, v, key) {
        var arr = Array.isArray(v) ? v : [v];
        return arr
          .map(function (x) {
            var f = (items || []).find(function (i) {
              return i.value === x;
            });
            return f ? f[key || "text"] : "";
          })
          .filter(Boolean)
          .join("، ");
      };

      var defs = [
        ["product", app.$t("product")],
        ["entrepot", app.$t("entrepot")],
        ["branch", app.$t("branch")],
        ["fromDate", app.$t("from") + " " + app.$t("date")],
        ["toDate", app.$t("until") + " " + app.$t("date")],
        ["statusControll", app.$t("statusControll"), pick(app.statusItems, app.statusControll)],
        ["documentType", app.$t("type"), pick(app.documentTypeItems, app.documentType)],
        ["invoiceType", app.$t("type") + " " + app.$t("invoice"), pick(app.invoiceTypeItems, app.invoiceType)],
        ["registerar", app.$t("registerar")],
      ];
      return defs
        .filter(function (d) {
          return has(app[d[0]]);
        })
        .map(function (d) {
          return { key: d[0], label: d[1], value: d.length > 2 ? d[2] : show(app[d[0]]) };
        });
    },
    proListKey () {
      return this.productTurnoverColumnPersistKey
    },
    proListLocked () {
      return this.productTurnoverLockedColumns
    },
    showSelect() {
      if (!this.isMobile) {
        return true;
      } else {
        return false;
      }
    },
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    isDesktopListViewport() {
      return !this.isMobile && !this.mobileShow;
    },
    productTurnoverColumnPersistKey() {
      return "product-turnover-columns-" + (this.$route.name || "productTurnover");
    },
    productTurnoverLockedColumns() {
      // Fixed sticky block: select + actions + row (no unpin/drag)
      var locked = ["actions"];
      return this.showSelect ? ["__select"].concat(locked) : locked;
    },
    productTurnoverColumnPlugins() {
      // show-select inserts a leading checkbox <th>; pad visibleHeaders so
      // pin/resize/drag index mapping stays aligned with thead cells.
      var selectHeader = {
        value: "__select",
        text: "",
        width: 32,
        sortable: false,
        pinned: false,
        originalIndex: -1,
      };
      var visible = this.showSelect
        ? [selectHeader].concat(this.tableHeaders || [])
        : this.tableHeaders || [];
      return {
        headers: this.headers,
        visibleHeaders: visible,
        locked: this.productTurnoverLockedColumns,
        anchor: "actions",
        minWidth: 60,
        persistKey: this.productTurnoverColumnPersistKey,
      };
    },
    showHeaders() {
      var app = this;
      return this.headers.filter(function (s) {
        if (app.$route.name === "productCountTurnover") {
          if (s.value === "price" || s.value === "sumAmount") {
          } else {
            return app.selectedHeaders.includes(s);
          }
        } else if (
          app.$route.name === "productTurnover" ||
          app.$route.name === "productTurnoverDetails"
        ) {
          if (s.value === "sumCount" || s.value === "sumAmount") {
          } else if (
            s.value === "invoiceArticle.fee" &&
            app.$route.name !== "productTurnoverDetails"
          ) {
          } else {
            return app.selectedHeaders.includes(s);
          }
        } else {
          if (app.$route.name === "productCountTurnover" && s.value === "sumAmount") {
          } else {
            return app.selectedHeaders.includes(s);
          }
        }
      });
    },
    totals: function () {
      const totals = this.items.reduce(
        (acc, d) => {
          acc.in += d.in ? parseFloat(d.in) : 0;
          acc.out += d.out ? parseFloat(d.out) : 0;
          return acc;
        },
        {
          in: 0,
          out: 0,
        }
      );
      return totals;
    },
  },
  watch: {
    idProp() {
      this.getItems();
    },
    refId(val, oldVal) {
      // this.items = []
      this.getItems();
    },
    model() {
      this.$emit("input", this.model);
    },
    entrepotProp(val) {
      this.getItems();
    },
    selected() {
      this.$emit("input", this.selected.text);
      if (this.selected.length > 0) {
        this.model = this.selected[0].text;
        this.temp = this.selected[0].text;
      }
      this.dialog = false;
    },
    search() {
      var app = this;
      app.loading = true;
      app.page = 1;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        app.getItems();
      }, 1000);
    },
    options: {
      handler() {
        var app = this;
        app.sortBy = [];
        app.options.sortBy.map(function (value, key) {
          const index = app.headers.findIndex((h) => h.value === value);
          app.sortBy.push(app.headers[index].table);
        });
        this.getItems();
      },
      deep: true,
    },
    sortBy() {
      const index = this.headers.findIndex((h) => h.value === this.sortBy);
      if (index > -1) {
        this.sortBy = this.headers[index].table;
      }
    },
    loading(val) {
      if (!val && this.isDesktopListViewport) {
        this.$nextTick(() => {
          this.bindListViewportObserver();
          this.scheduleDesktopTableHeightUpdate();
        });
      }
    },
    isDesktopListViewport(val) {
      if (val) {
        this.$nextTick(() => {
          this.updateDesktopTableHeight();
          this.bindListViewportObserver();
        });
      } else {
        this.unbindListViewportObserver();
        this.tableHeight = window.innerHeight - 245;
      }
    },
  },
  activated() {
    if (this.isDesktopListViewport) {
      this.$nextTick(() => {
        this.bindListViewportObserver();
        this.scheduleDesktopTableHeightUpdate();
      });
    }
  },
  beforeMount() {
    if (this.$route.name === "purchaseList") {
      this.type = "purchase";
    }
    if (this.$route.name === "presaleList") {
      this.type = "presale";
    }
    if (this.$route.name === "sellList") {
      this.type = "sell";
    }
    if (this.$route.name === "purchaseReturnList") {
      this.type = "purchaseReturn";
    }
    if (this.$route.name === "sellReturnList") {
      this.type = "sellReturn";
    }
    this.headers = [
      {
        text: this.$t("#"),
        align: "center",
        sortable: false,
        value: "actions",
        width: 42,
        class: "pl-action-col",
        cellClass: "pl-action-col",
      },
      {
        text: this.$t("type"),
        sortable: true,
        value: "head.type",
        table: "entrepot_head.type",
      },
      {
        text: this.$t("entrepot"),
        sortable: true,
        value: "entrepot.name",
        table: "entrepots.name",
      },
      {
        text: this.$t("date"),
        sortable: true,
        value: "head.date",
        table: "entrepot_head.date",
      },
      {
        text: this.$t("product"),
        sortable: true,
        value: "product.name",
        table: "products.name",
      },
      {
        text: this.$t("in"),
        sortable: true,
        value: "in",
        table: "entrepot_article.in",
      },
      {
        text: this.$t("out"),
        sortable: true,
        value: "out",
        table: "entrepot_article.out",
      },
      {
        text: this.$t("countCheckByStorekeeper"),
        sortable: true,
        value: "checked_count",
        table: "entrepot_article.checked_count",
      },
      {
        text: this.$t("unit"),
        sortable: false,
        value: "unit.fame",
      },
      {
        text: this.$t("fee"),
        sortable: true,
        value: "price",
        table: "entrepot_article.price",
      },
      //add sellPrice in /details
      {
        text: this.$t("sellPrice"),
        sortable: true,
        value: "invoiceArticle.fee",
        table: "invoice_articles.fee",
      },
      {
        text: this.$t("remain"),
        sortable: false,
        value: "sumCount",
      },
      {
        text: this.$t("sumAmount"),
        sortable: false,
        value: "sumAmount",
      },
      {
        text: this.$t("registerar"),
        sortable: false,
        value: "user.name",
      },
    ];
    this.headersMap = this.headers;
    this.selectedHeaders = this.headers;
    reorderPinnedHeaders(this.headers, {
      locked: this.productTurnoverLockedColumns,
      anchor: "actions",
    });
    this.loadProductTurnoverColumnSettings();
    this.productStatusItems = [
      {
        value: "active",
        text: this.$t("active"),
      },
      {
        value: "deactive",
        text: this.$t("deactive"),
      },
    ];
    if (this.input) {
      this.model = this.input;
    }
    this.statusItems = [
      {
        value: "LeavingTheWarehouse",
        text: this.$t("LeavingTheWarehouse"),
      },
      {
        value: "LogInWarehouse",
        text: this.$t("LogInWarehouse"),
      },
      {
        value: "storekeeperCountError",
        text: this.$t("storekeeperCountError"),
      },
    ];
    //for filter
    this.documentTypeItems = [
      { value: "initial", text: this.$t("initial") },
      { value: "remittance", text: this.$t("remittance") },
      { value: "warehouseHandling", text: this.$t("warehouseHandling") },
      { value: "receipt", text: this.$t("receipt") },
    ];
    this.invoiceTypeItems = [
      { value: "purchase", text: this.$t("purchase") },
      { value: "sell", text: this.$t("sell") },
      { value: "returnPurchase", text: this.$t("returnPurchaseList") },
      { value: "returnSell", text: this.$t("returnSellList") },
    ];
  },
  mounted() {
    if (this.isDesktopListViewport) {
      this.$nextTick(() => {
        this.bindListViewportObserver();
        this.updateDesktopTableHeight();
        this.$nextTick(() => {
          this.bindListViewportObserver();
          this.scheduleDesktopTableHeightUpdate();
        });
      });
    }
  },
  deactivated() {
    this.unbindListViewportObserver();
  },
  beforeDestroy() {
    this.unbindListViewportObserver();
    if (this.listViewportRaf) {
      cancelAnimationFrame(this.listViewportRaf);
      this.listViewportRaf = null;
    }
  },
  methods: {

    resetFilters() {
      var app = this;
      [
        "product", "entrepot", "branch", "fromDate", "toDate",
        "statusControll", "documentType", "invoiceType", "registerar",
      ].forEach(function (k) {
        app[k] = null;
      });
    },
    resolveRefEl(ref) {
      if (!ref) return null;
      return ref.$el || ref;
    },
    onResize() {
      if (this.isDesktopListViewport) {
        this.updateDesktopTableHeight();
        return;
      }
      this.tableHeight = window.innerHeight - 245;
    },
    scheduleDesktopTableHeightUpdate() {
      if (this.listViewportRaf) cancelAnimationFrame(this.listViewportRaf);
      this.listViewportRaf = requestAnimationFrame(() => {
        this.listViewportRaf = null;
        this.updateDesktopTableHeight();
      });
    },
    updateDesktopTableHeight() {
      if (!this.isDesktopListViewport) {
        this.tableHeight = window.innerHeight - 245;
        return;
      }
      const rootEl = this.resolveRefEl(this.$refs.listRoot);
      const toolbarEl = this.resolveRefEl(this.$refs.listToolbar);
      const summaryEl = this.resolveRefEl(this.$refs.listSummary);
      const tableColEl = this.resolveRefEl(this.$refs.listTableCol);
      const tableEl = this.resolveRefEl(this.$refs.listTable);
      if (!rootEl || !tableColEl) {
        this.tableHeight = window.innerHeight - 245;
        return;
      }
      const rootStyle = window.getComputedStyle(rootEl);
      const rootPadding =
        (parseFloat(rootStyle.paddingTop) || 0) +
        (parseFloat(rootStyle.paddingBottom) || 0);
      const toolbarHeight = toolbarEl ? toolbarEl.offsetHeight : 0;
      let summaryHeight = 0;
      if (summaryEl) {
        const summaryVisible =
          summaryEl.offsetParent !== null || summaryEl.getClientRects().length > 0;
        if (summaryVisible) {
          const summaryStyle = window.getComputedStyle(summaryEl);
          summaryHeight =
            summaryEl.offsetHeight +
            (parseFloat(summaryStyle.marginTop) || 0) +
            (parseFloat(summaryStyle.marginBottom) || 0);
        }
      }
      const colStyle = window.getComputedStyle(tableColEl);
      const colPadding =
        (parseFloat(colStyle.paddingTop) || 0) +
        (parseFloat(colStyle.paddingBottom) || 0);
      const footerEl = tableEl ? tableEl.querySelector(".v-data-footer") : null;
      const footerHeight = footerEl ? footerEl.offsetHeight : 0;
      const tableStyle = tableEl ? window.getComputedStyle(tableEl) : null;
      const tableMargins = tableStyle
        ? (parseFloat(tableStyle.marginTop) || 0) +
          (parseFloat(tableStyle.marginBottom) || 0)
        : 0;
      const available =
        rootEl.clientHeight -
        rootPadding -
        toolbarHeight -
        summaryHeight -
        colPadding -
        footerHeight -
        tableMargins -
        3;
      this.tableHeight = Math.max(180, Math.floor(available));
    },
    bindListViewportObserver() {
      if (typeof ResizeObserver === "undefined") return;
      this.unbindListViewportObserver();
      const rootEl = this.resolveRefEl(this.$refs.listRoot);
      const summaryEl = this.resolveRefEl(this.$refs.listSummary);
      const tableColEl = this.resolveRefEl(this.$refs.listTableCol);
      const tableEl = this.resolveRefEl(this.$refs.listTable);
      const footerEl = tableEl ? tableEl.querySelector(".v-data-footer") : null;
      if (!rootEl && !summaryEl && !tableColEl) return;
      this.listViewportObserver = new ResizeObserver(() => {
        this.scheduleDesktopTableHeightUpdate();
      });
      if (rootEl) this.listViewportObserver.observe(rootEl);
      if (summaryEl) this.listViewportObserver.observe(summaryEl);
      if (tableColEl) this.listViewportObserver.observe(tableColEl);
      if (footerEl) this.listViewportObserver.observe(footerEl);
    },
    unbindListViewportObserver() {
      if (this.listViewportObserver) {
        this.listViewportObserver.disconnect();
        this.listViewportObserver = null;
      }
    },
    loadProductTurnoverColumnSettings() {
      var app = this;
      if (!app.headers || !app.headers.length) return;
      loadColumnSettings(app, app.productTurnoverColumnPersistKey).then(function (snapshot) {
        if (!snapshot || !snapshot.length) return;
        applyColumnSettings(app.headers, snapshot, {
          locked: app.productTurnoverLockedColumns,
          anchor: "actions",
        });
        app.$forceUpdate();
      });
    },
    openDeleteDialog(item) {
      this.deleteItem = item;
      this.deletDialog = true;
    },
    openTaskDialog(item) {
      this.refId = item.rel_id;
      this.taskId = item.id;
      this.taskDialog = true;
    },
    isEnabled(slot) {
      return this.enabled === slot;
    },
    edit(item) {
      this.$router.push({ name: item.head.type + "Edit", params: { id: item.head.id } });
    },
    invoice(item) {
      if (item.head.type === "production") {
        // this.$router.push({ name: item.head.production.type + 'Edit', params: { id: item.head.production.id } })
      } else {
        // this.$router.push({ name: item.head.invoice.type + 'Edit', params: { id: item.head.invoice.uid } })
      }
    },
    getItems() {
      var app = this;
      app.filter = false;
      app.loading = true;
      var productId = app.productProp ? app.productProp.id : null;
      productId = this.$route.params.id ? this.$route.params.id : productId;
      app.$axios
        .get(this.$endpoint + "productsreport", {
          params: {
            product_id: app.product ? app.product.id : null,
            productProp_id: productId,
            entrepotProp: !app.entrepot ? app.entrepotProp : null,
            entrepot: app.entrepot,
            search: app.search,
            page: app.allRows ? app.excelPage : app.options.page,
            refId: app.refId,
            statusControll: app.statusControll,
            branch: app.branch,
            idProp: app.idProp,
            type: app.type,
            fromDate: app.fromDate,
            toDate: app.toDate,
            report: "turnover",
            sortBy: app.sortBy,
            status: app.productStatus,
            options: app.options,
            tag: app.tag,
            documentType: app.documentType,
            invoiceType: app.invoiceType,
            registerar: app.registerar,
            typeForm: app.typeForm,
            name: app.$route.name,
          },
        })
        .then((res) => {
          res = res.data;
          if (!app.allRows) {
            app.items = res.data;
            app.totalItems = res.total;
            app.pageCount = res.last_page;
            app.from = res.from;
            app.creatExcelData(res.data);
          } else {
            app.generateExcellForAllData(res.data, res.last_page);
          }
          if (app.options.page === 1) {
            app.sumAmount = 0;
            app.sumCount = 0;
          }
          app.items.map(function (value, key) {
            if (value.in > 0 || value.out > 0) {
              if (value.in > 0) {
                app.sumAmount =
                  parseFloat(app.sumAmount) +
                  parseFloat(value.price) * parseFloat(value.in);
                app.sumCount = parseFloat(app.sumCount) + parseFloat(value.in);
              } else {
                app.sumCount = parseFloat(app.sumCount) - parseFloat(value.out);
                app.sumAmount =
                  parseFloat(app.sumAmount) -
                  parseFloat(value.price) * parseFloat(value.out);
              }
            }
            value.sum = app.sumAmount;
            value.sumCount = app.sumCount;
          });
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    remove() {
      var app = this;
      if (!app.deleteItem) return false;
      app.loading = true;
      app.$axios
        .delete(this.$endpoint + "invoice/" + this.deleteItem.id)
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
          app.getItems();
        })
        .catch((err) => {
          this.deletDialog = false;
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    removegroup() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "invoice", {
          params: {
            deleteItems: app.selected,
          },
        })
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
          app.selected = [];
          app.getItems();
        })
        .catch((err) => {
          this.deletDialog = false;
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    creatExcelData(data, type = "page") {
      var app = this;
      if (type === "page") {
        app.excelItems = [];
      }
      data.map(function (d) {
        app.excelItems.push({
          id: d.id,
          type: app.$t(d.head.type) + " " + app.$t("number") + " " + d.head.id,
          warehouse: d.entrepot ? d.entrepot.name : "",
          date: d.head ? d.head.date : "",
          product: d.product ? d.product.name : "",
          unit: d.unit ? d.unit.fame : "",
          in: d.in,
          out: d.out,
          fee: d.price,
          sellPrice: d?.invoiceArticle?.fee ?? "",
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/sass/design-system/list/pro-list";

::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
  > .v-input__control
  > .v-input__slot {
  min-height: 32px !important;
}
</style>
